import axios from "axios";
import { baseURL } from "../../constants/Api";

export const fetch_all_events = async () => {
  let config = {
    method: "get",
    url: `${baseURL}/api/events`,
    headers: {
      Accept: "application/json",
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const book_events = async (bookedFor, eventId, hotelId, appUserId, amount,reservationId, guestId, contactName) => {
  console.log(bookedFor, eventId, hotelId, appUserId, amount,reservationId, guestId, contactName)
   let config = {
    method: "post",
    url: `${baseURL}/api/eventV21`,
    headers: {
      Accept: "application/json",
    },
    data: {
      bookedFor,
      appUserId: parseInt(appUserId),
      contactName: "",
      eventId,
      roomNumber: "",
      hotelId,
      amount ,
      // reservationId,
      // guestId,
      contactName
        },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetch_event_history = async (appUserId) => {
  let config = {
    method: "post",
    url: `${baseURL}/api/eventBookedHistory`,
    headers: {
      Accept: "application/json",
    },
    data: { 
      appUserId,
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
